<div class="ui-input">
  @if (label) {
    <label class="ui-input__label" [for]="id">{{ label }}</label>
  }

  @if (type === 'textarea') {
    <textarea
      class="ui-input__control ui-input__control--textarea"
      [id]="id"
      [name]="name"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [rows]="rows"
      [attr.required]="required ? '' : null"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
    ></textarea>
  } @else {
    <div class="ui-input__field">
      <input
        class="ui-input__control"
        [class.ui-input__control--with-toggle]="type === 'password' && togglePassword"
        [id]="id"
        [type]="effectiveType"
        [name]="name"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [attr.required]="required ? '' : null"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
      />
      @if (type === 'password' && togglePassword) {
        <button
          type="button"
          class="ui-input__toggle"
          [attr.aria-label]="passwordVisible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
          tabindex="-1"
          (click)="togglePasswordVisibility()"
        >
          <ui-icon [name]="passwordVisible ? 'eye-off' : 'eye'" size="sm" />
        </button>
      }
    </div>
  }

  @if (hint && !error) {
    <p class="ui-input__hint">{{ hint }}</p>
  }

  @if (error) {
    <p class="ui-input__error">{{ error }}</p>
  }
</div>
